/*@flow*/
import type { Node } from 'react';
import GetStarted from './GetStarted';
import FormulaWidget from './FormulaWidget';
import React, { useState, useEffect, useContext } from 'react';
import MetricsContext from './MetricsContext';
import type { State$DataviewUrlMap, Metric, Metric$Widget } from './types';

const toWidget = ({
  metric,
  dataviewUrls,
}: {
  metric: Metric,
  dataviewUrls: State$DataviewUrlMap,
}): Metric$Widget => {
  const { id, name, ...rest } = metric;
  const dId = 'c-' + id;
  const url = dataviewUrls[dId];
  return {
    ...rest,
    id,
    label: name,
    url,
  };
};

export default (): any | null | Node => {
  const [isLoading, setLoading] = useState(true);
  const ctx = useContext(MetricsContext);
  const {
    dataviewUrls,
    placeMetrics,
    placeMetricsOrder,
    selectedMetrics,
  } = ctx.state;
  const filterFn = (v) => selectedMetrics.includes(v.id);
  const active = placeMetrics.filter(filterFn);
  let widgets = active.map((v) => toWidget({ metric: v, dataviewUrls }));
  widgets = placeMetricsOrder
    .map((id) => widgets.find((v) => String(v.id) === String(id)))
    .filter(Boolean);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 50);
    return () => clearTimeout(timer);
  }, []);

  if (widgets.length > 0) {
    return widgets.map((v, i) => <FormulaWidget {...v} key={i} />);
  }
  return isLoading ? null : <GetStarted />;
};
